import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './../utils';

const LayoutElementFields = {
  group: ELEMENT_GROUPS.LAYOUTS,
  disableAdd: false,
  label: 'Layout',
  icon: 'ViewColumnsIcon',
  description: 'Add a layout of columns',
  properties: [
    {
      name: 'exitDesignerPreview',
      label: 'Turn Preview Off',
      description:
        'If true, any elements contained within this layout will be rendered separately in the designer outside of the layout. The layout will not provide a preview of what its children will look like',
      editor: 'switch',
      type: 'boolean',
      default: false,
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      name: 'text',
      label: 'Text',
      description: '',
      editor: 'textbox',
      type: 'string',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Use on Tablets in Portrait',
      name: 'useOnTabletInPortrait',
      editor: 'boolean',
      default: false,
      description:
        'If true, this layout is evaluated when the app is running a tablet in portrait orientation',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Tablet Columns - (Portrait)',
      name: 'columnsTabletPortrait',
      editor: 'number',
      description:
        'The number of columns to display when the app is running on a tablet in portrait orientation',
      default: 2,
      displayWhen: [
        { field: 'useOnTabletInPortrait', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Use on Tablets in Landscape',
      name: 'useOnTabletInLandscape',
      editor: 'boolean',
      default: false,
      description:
        'If true, this layout is evaluated when the app is running a tablet in landscape orientation',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Tablet Columns - (Landscape)',
      name: 'columnsTabletLandscape',
      editor: 'number',
      description:
        'The number of columns to display when the app is running on a tablet in landscape orientation',
      default: 3,
      displayWhen: [
        { field: 'useOnTabletInLandscape', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Use on Phones in Portrait',
      name: 'useOnPhoneInPortrait',
      editor: 'boolean',
      default: true,
      description:
        'If true, this layout is evaluated when the app is running a phone in portrait orientation',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Phone Columns - (Portrait)',
      name: 'columnsPhonePortrait',
      editor: 'number',
      description:
        'The number of columns to display when the app is running on a phone in portrait orientation',
      default: 2,
      displayWhen: [
        { field: 'useOnPhoneInPortrait', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Use on Phones in Landscape',
      name: 'useOnPhoneInLandscape',
      editor: 'boolean',
      default: false,
      description:
        'If true, this layout is evaluated when the app is running a phone in landscape orientation',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Phone Columns - (Landscape)',
      name: 'columnsPhoneLandscape',
      editor: 'number',
      description:
        'The number of columns to display when the app is running on a phone in landscape orientation',
      default: 2,
      displayWhen: [
        { field: 'useOnPhoneInLandscape', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'justifyContentTabletLandscape',
      label: 'Justify Content - Tablet (Landscape)',
      description:
        'The horizontal positioning of column content in this layout on a Tablet in Landscape orientation. Only applies to column elements that are not marked as full width elements.',
      editor: 'dropdown',
      type: 'string',
      options: [
        { label: 'Left', value: 'flex-start' },
        { label: 'Center', value: 'center' },
        { label: 'Right', value: 'flex-end' },
        { label: 'Space Between', value: 'space-between' },
        { label: 'Space Around', value: 'space-around' },
        { label: 'Space Evenly', value: 'space-evenly' }
      ],
      displayWhen: [
        { field: 'useOnTabletInLandscape', operator: '=', value: true }
      ],
      default: 'space-evenly',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'justifyContentTabletPortrait',
      label: 'Justify Content - Tablet (Portrait)',
      description:
        'The horizontal positioning of column content in this layout on a Tablet in Portrait orientation. Only applies to column elements that are not marked as full width elements.',
      editor: 'dropdown',
      type: 'string',
      options: [
        { label: 'Left', value: 'flex-start' },
        { label: 'Center', value: 'center' },
        { label: 'Right', value: 'flex-end' },
        { label: 'Space Between', value: 'space-between' },
        { label: 'Space Around', value: 'space-around' },
        { label: 'Space Evenly', value: 'space-evenly' }
      ],
      displayWhen: [
        { field: 'useOnTabletInPortrait', operator: '=', value: true }
      ],
      default: 'space-evenly',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'justifyContentPhoneLandscape',
      label: 'Justify Content - Phone (Landscape)',
      description:
        'The horizontal positioning of column content in this layout on a Phone in Landscape orientation. Only applies to column elements that are not marked as full width elements.',
      editor: 'dropdown',
      type: 'string',
      options: [
        { label: 'Left', value: 'flex-start' },
        { label: 'Center', value: 'center' },
        { label: 'Right', value: 'flex-end' },
        { label: 'Space Between', value: 'space-between' },
        { label: 'Space Around', value: 'space-around' },
        { label: 'Space Evenly', value: 'space-evenly' }
      ],
      displayWhen: [
        { field: 'useOnPhoneInLandscape', operator: '=', value: true }
      ],
      default: 'space-evenly',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'justifyContentPhonePortrait',
      label: 'Justify Content - Phone (Portrait)',
      description:
        'The horizontal positioning of column content in this layout on a Phone in Portrait orientation. Only applies to column elements that are not marked as full width elements.',
      editor: 'dropdown',
      type: 'string',
      options: [
        { label: 'Left', value: 'flex-start' },
        { label: 'Center', value: 'center' },
        { label: 'Right', value: 'flex-end' },
        { label: 'Space Between', value: 'space-between' },
        { label: 'Space Around', value: 'space-around' },
        { label: 'Space Evenly', value: 'space-evenly' }
      ],
      displayWhen: [
        { field: 'useOnPhoneInPortrait', operator: '=', value: true }
      ],
      default: 'space-evenly',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    'font',
    'alignment',
    'margin',
    {
      name: 'padding',
      label: 'Padding',
      description: '',
      editor: 'boundary',
      type: 'string',
      default: '10 10 10 10',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'columnPadding',
      label: 'Column Padding',
      description: '',
      editor: 'boundary',
      type: 'string',
      default: '0 10 0 10',
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Container Border Color',
      name: 'borderColor',
      editor: 'color',
      description: 'The border color of the layout container',
      default: '#182fa4',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Container Border Radius',
      name: 'borderRadius',
      editor: 'number',
      description: 'The border radius of the layout container',
      default: 0,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Container Border Width',
      name: 'borderWidth',
      editor: 'number',
      description: 'The border width of the layout container',
      default: 0,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Column Border Color',
      name: 'columnBorderColor',
      editor: 'color',
      description: 'The border color of a column',
      default: '#182fa4',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Column Border Radius',
      name: 'columnBorderRadius',
      editor: 'number',
      description: 'The border radius of a column',
      default: 0,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Column Border Width',
      name: 'columnBorderWidth',
      editor: 'number',
      description: 'The border width of a column',
      default: 0,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      label: 'Column Widths',
      name: 'columnWidths',
      editor: 'textbox',
      description: 'An optional comma separated list of numeric column widths.',
      default: 0,
      group: ELEMENT_ATTRIBUTE_GROUP.LAYOUT
    },
    {
      name: 'color',
      label: 'Color',
      description: '',
      editor: 'color',
      type: 'string',
      default: '#000000',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Show Background Image',
      name: 'showBackgroundImage',
      editor: 'boolean',
      default: false,
      description: 'If the button should include an icon',
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    },
    {
      name: 'backgroundImage',
      label: 'Background Image',
      description: '',
      editor: 'image',
      mediaLibraryStoreIn: 'custom_folder',
      mediaLibraryPath: 'apps',
      type: 'string',
      default: '#182fa4',
      displayWhen: [
        { field: 'showBackgroundImage', operator: '=', value: true }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    },
    {
      name: 'backgroundColor',
      label: 'Background Color',
      description: '',
      editor: 'color',
      type: 'string',
      default: '',
      displayWhen: [
        {
          field: 'showBackgroundImage',
          operator: 'DOES_NOT_EQUAL',
          value: true
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    }
  ]
};

export default LayoutElementFields;
